import { TouchableOpacity, View } from "react-native";
import TextLink from "../../shared-components/buttons/TextLink";
import TextPrimary from "../../shared-components/text/TextPrimary";
import navigationNames from "../navigationNames";

interface HeaderRightProps {
  onPress: (pageName: string, config?: object) => void;
}

const HeaderRight = (props: HeaderRightProps) => {
  return (
    <>
      <View
        style={{
          flexDirection: "row",
          paddingRight: 16,
        }}
      >
        {/* // TAG : Home */}
        <TextLink
          viewStyle={{ padding: 8 }}
          label="Home"
          onPress={() => {
            props.onPress(navigationNames.home.id, {});
          }}
        />
        {/* // TAG : Documentations */}
        <TextLink
          label={navigationNames.docs.title}
          viewStyle={{ padding: 8 }}
          onPress={() => {
            props.onPress(navigationNames.docs.id, {});
          }}
        />
        {/* // TAG : About */}
        <TextLink
          label={navigationNames.about.title}
          viewStyle={{ paddingVertical: 8, paddingLeft: 8 }}
          onPress={() => {
            props.onPress(navigationNames.about.id, {});
          }}
        />
      </View>
    </>
  );
};

export default HeaderRight;
